import React, { Component } from 'react';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
axios
  .get(apiServerUrl + '/teams', requestOptions())
  .then(function(response) {
    ////console.log("compenen mount respone " + JSON.stringify(awayTeam));
    const teamsData = React.createContext(response);
    //console.log(teamsData);
  })
  .catch(function(error) {
    //console.log(error);
  });

export const teamsData = React.createContext(teamsData);



// WEBPACK FOOTER //
// ./src/Pages/dataUrls.js